import Sentry from '../sentry';

export function captureRef() {
  Sentry.captureMessage('captureRef is not supported on web');
}
